import axiosInstance from './authService.js';

const PAYMENT_API_BASE_URL  = process.env.REACT_APP_API_BASE_URL;


export const submitPaymentProof = async (proofData) => {
    // proofData will contain: { amount, paymentDate, bank, transactionId, proofImage, notes }

    const formData = new FormData();
    formData.append('amount', proofData.amount);
    formData.append('payment_date', proofData.paymentDate); // Match backend field name
    formData.append('bank_name', proofData.bank);           // Match backend field name
    // Only append transactionId and notes if they have values
    if (proofData.transactionId) {
        formData.append('transaction_id', proofData.transactionId);
    }
    if (proofData.notes) {
        formData.append('notes', proofData.notes);
    }

    // Ensure proofData.proofImage is a File object before appending
    if (proofData.proofImage instanceof File) {
        formData.append('proof_image', proofData.proofImage); // Append the File object
    } else {
        // This is a client-side validation that should ideally happen earlier
        console.error("proofImage is not a File object:", proofData.proofImage);
        throw new Error("Invalid image file provided. Please select an image.");
    }

    try {
        const response = await axiosInstance.post(`${PAYMENT_API_BASE_URL}/api/payments/submit-proof/`, formData, {
            headers: {
                'Content-Type': undefined, 
            },
        });
        return response.data;
    } catch (error) {
        console.error('API Error submitting payment proof:', error.response?.data || error.message);
        throw new Error(error.response?.data?.detail || 'Failed to submit payment proof to server.');
    }
};

// You might add other payment-related functions here in the future, e.g.,
// export const getPaymentHistory = async () => { ... }